<mat-toolbar class="toolbar-sm">
    <img src="app/assets/images/expand-rows-down.png" width="16" height="16" id="expandRowsDown"
        matTooltip="{{engLang ? 'Expand All Claims' : 'Expandir todos los casos'}}" matTooltipPosition="above"
        (click)="onClick_menu($event)" style="cursor: pointer;">

    <img src="app/assets/images/collapse-rows-up.png" width="16" height="16" id="collapseRowsUp"
        matTooltip="{{engLang ? 'Collapse All Claims' : 'Colapsar todos los casos'}}" matTooltipPosition="above"
        (click)="onClick_menu($event)" style="cursor: pointer;">

    <i class="fa fa-trash font12" id="delete" matTooltip="{{ engLang ? 'Delete Report': 'Eliminar Reporte' }}"
        matTooltipPosition="above" (click)=" onClick_menu($event)" style="cursor: pointer;"></i>

    <i class="far fa-file-excel font13" matTooltipPosition="above" id="exportToExcel" matTooltip="Excel"
        (click)="onClick_menu($event)" style="cursor: pointer;"></i>

    <mat-icon class="font15 pt-1" matTooltip="{{engLang ? 'Print' : 'Imprimir'}}" matTooltipPosition="above"
        (click)="insPrintAllInsOnly=true; printRpt(undefined,false)" id="print"
        style="cursor: pointer; font-size: 1rem;">print</mat-icon>
</mat-toolbar>

<mat-form-field style="height: 75px; min-height: 75px; width: 100%;">
    <mat-label class="font13">{{engLang ? 'Select from past reports' : 'Seleccione de reportes
        pasados'}}</mat-label>
    <mat-select (selectionChange)="onChange_view($event.value)" class="text-center" style="font-size: 14px;">
        <mat-option *ngFor="let v of rptIncomeData().views" [value]="v.name">
            <span style="font-size: 13px;">{{engIncomeDescr(v.name)}}</span>
        </mat-option>
    </mat-select>
</mat-form-field>